import styled from 'styled-components';
import { motion } from 'framer-motion';

export const PopupContainer = styled(motion.div)`
position: fixed;
width: 100%;
height: 100%;
background: rgba(0,0,0,0.4);
padding: 0 25px;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);
z-index: 2;

display: flex;
justify-content: center;
align-items: center;
`;

export const PopupWrapper = styled(motion.div)`
position: relative;
padding: 25px;
width: 100%;
max-width: 640px;
background: #fff;
border-radius: 10px;
display: flex;
flex-direction: column;
`;

export const PopupCloseButton = styled.button`
position: absolute;
top: 15px;
right: 15px;
font-size: 25px;
color: #33682c;
border: none;
background: none;

&:hover {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
}
`;

export const PopupHeader = styled.h3`
font-size: 18px;
color: #000;
margin-bottom: 15px;

@media screen and (max-width: 480px){
    font-size: 16px;
}
`;
